import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { AGG_HEX_SPEED_LEGEND } from '../../../constants/legends';

const aggHexSpeedComponent = () => (
    <LegendRenderer config={AGG_HEX_SPEED_LEGEND} />
);

export const AggHexSpeedLegend = withDisplayedLayersCheck(
    aggHexSpeedComponent,
    `${t`Медианная скорость`} (${t`вчера`})`
);

